import { ArrowForwardIos } from '@mui/icons-material';
import React from 'react'
import { Link, useLocation } from 'react-router-dom';

const EasyBinTransfer_Breadcrumbs = () => {
    const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/EasyBinTransferSummary" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Summary
          </span>
        </div>
      ) : vPathName === "/EasyItemTransfer" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/EasyBinTransferSummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
           Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              EasyItem{" "}
            </span>
          </div>
        </div>
      ) :vPathName === "/EasyItemTransferDetail" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/EasyBinTransferSummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
           Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <Link
            to="/EasyItemTransfer"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            EasyItem
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              EasyItemDetail{" "}
            </span>
          </div>
        </div>
      ): vPathName === "/EasyCardIdTransfer" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/EasyBinTransferSummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              EasyCardId{" "}
            </span>
          </div>
        </div>
      ) :vPathName === "/EasyCardIdTransferDetail" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/EasyBinTransferSummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <Link
            to="/EasyCardIdTransfer"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            EasyCardId
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              EasyCardIdDetail{" "}
            </span>
          </div>
        </div>
      ): vPathName === "/EasyBinTransfer" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/EasyBinTransferSummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
             Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              EasyBin{" "}
            </span>
          </div>
        </div>
      ) :vPathName === "/EasyBinTransferDetail" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/EasyBinTransferSummary"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Summary
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <Link
            to="/EasyBinTransfer"
            state={location}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            EasyBin 
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              EasyBinDetail{" "}
            </span>
          </div>
        </div>
      ):(
        <></>
      )}
    </div>
  )
}

export default EasyBinTransfer_Breadcrumbs;
